/* tslint:disable */

import { FlowchartElementType } from './FlowchartElementType';
import { GuidelineChapterType } from './GuidelineChapterType';
import { UserDto } from './UserDto';

export class ProposedComponentDto {
  code?: string;
  title?: string;
  description?: string;
  followedByComponentCode?: string;
  followedByComponentVersion?: string;
  proposingOrganisationId?: string | null;
  shouldNotBePromoted?: boolean | null;
  proposedInFlowchartElementType?: FlowchartElementType;
  proposedInGuidelineChapterType?: GuidelineChapterType;
  authorId?: string | null;
  author?: UserDto;
  editorId?: string | null;
  editor?: UserDto;
  createdAt?: Date | null;
  updatedAt?: Date | null;
}
